import { render } from "./ComponentDetailProject.vue?vue&type=template&id=0e04bb77&scoped=true"
import script from "./ComponentDetailProject.vue?vue&type=script&lang=js"
export * from "./ComponentDetailProject.vue?vue&type=script&lang=js"

import "./ComponentDetailProject.vue?vue&type=style&index=0&id=0e04bb77&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e04bb77"]])

export default __exports__